import { Outlet } from 'react-router-dom';
import SideNav from './SideNav';
import { getAuthData } from '../../utils/auth'; // make sure this path is correct
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@/store';
import { setSidebarCollapsed } from '@/reducers/app-global-slice';

const PrivateRoutes: React.FC = () => {
  const { role } = getAuthData();
  const isSidebarCollapsed = useSelector(
    (state: RootState) => state.sidebarCollapse.isSidebarCollapsed
  );

  const dispatch = useDispatch();
  const isCollapsed = isSidebarCollapsed;
  const showSideNav = role === 'admin';

  const toggleSidebar = () => {
    dispatch(setSidebarCollapsed(!isCollapsed));
  };

  return (
    <div className="flex h-screen bg-ds-purple-100 p-2 ">
      <div className=" mx-2 bg-white h-full rounded-lg ">
        {showSideNav && <SideNav isCollapsed={isCollapsed} toggleSidebar={toggleSidebar} />}
      </div>
      <div className="flex-grow transition-all duration-300">
        <div className="h-full">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default PrivateRoutes;
